import React from 'react';
import { useProperty } from '../hooks/useProperty';
import { useLocation } from 'react-router-dom';
import formatAddress from '../utility/formatAddress';

//must be used in a property context
export default function PropertyMap() {
  const { propertyData } = useProperty();
  const { pathname } = useLocation();
  const sharing = pathname.includes('sharing');

  const { shareAddress, propertyAddress } = propertyData || {};

  const canShareAddress = !sharing || shareAddress;

  const formattedAddress = Array.isArray(propertyAddress)
    ? formatAddress(propertyAddress, 'long')
        .replace(/,/g, '')
        .replace(/ /g, '+')
    : null;

  const googlemapApi = process.env.GOOGLE_MAPS_KEY;

  return (
    <div className="w-full flex justify-center items-center h-full">
      {formattedAddress && canShareAddress && (
        <iframe
          className="rounded-lg w-full h-full max-w-[800px] max-h-[500px] min-h-[300px]"
          style={{ border: 0 }}
          src={`https://www.google.com/maps/embed/v1/place?key=${googlemapApi}&q=${formattedAddress}`}
          allowFullScreen
        ></iframe>
      )}
      {(!formattedAddress || !canShareAddress) && (
        <div className="w-full h-full min-h-[300px] max-w-[800px] max-h-[500px] flex justify-center  rounded-lg items-center  bg-white">
          <p className="text-black text-center text-md max-w-sm px-4">
            No address available for this property. Please add a valid address
            to view the map.
          </p>
        </div>
      )}
    </div>
  );
}
